/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconEngine = createReactComponent("engine", "IconEngine", [
  ["path", { d: "M3 10v6", key: "svg-0" }],
  ["path", { d: "M12 5v3", key: "svg-1" }],
  ["path", { d: "M10 5h4", key: "svg-2" }],
  ["path", { d: "M5 13h-2", key: "svg-3" }],
  [
    "path",
    {
      d: "M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z",
      key: "svg-4"
    }
  ]
]);

export { IconEngine as default };
//# sourceMappingURL=IconEngine.js.map
